<template>
    <b-row>
        <!--
        <b-col md="5" class="ml-2 my-2 d-flex align-items-center">
            <span class="badge badge-secondary">
                Estado SGD:
            </span>
            <span v-if="isSGDOn" class="ml-2 badge badge-success">
                online
            </span>
            <span v-else class="ml-2 badge badge-danger">
                offline
            </span>
        </b-col>
        <b-col md="6" class="ml-2 my-2 d-flex align-items-center">
            <span class="badge badge-secondary">
                Estado WSS:
            </span>
            <span class="ml-2 badge" :class="indicatorClasses">
                {{ wsStatus }}
            </span>
        </b-col>
        -->
    </b-row>
</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
// import wsService from '@/services/websocket';

export default {
    data() {
        return {
            // DATA STATUS SGD
            isSGDOn: true,
            idInterval: null,
        };
    },
    computed: {
        ...mapGetters({
            wsStatus: "auth/wsStatus",
        }),
        indicatorClasses() {
            return {
                'badge-warning': this.wsStatus === 'disconnected',
                'badge-info': this.wsStatus === 'connecting',
                'badge-success': this.wsStatus === 'connected',
                'badge-danger': this.wsStatus === 'error',
            };
        },
    },
    mounted() {
        // this.onGetStatusSgd();
        // wsService.on('status-sgd', this.handleData);
        // wsService.on('ws-status', this.handleWsStatus);
    },
    methods: {
        // METHOD STATUS SGD
        onGetStatusSgd() {
            axios.post("/sendEvent/1",).then((res) => {
                if (res.status === 200 && res.data?.data?.data?.Ws_Sgd_Buscar_PendResult?.descRespuesta === "OK") {
                    this.isSGDOn = true;
                } else {
                    this.isSGDOn = false;
                }
            }).catch((e) => {
                this.isSGDOn = false;
                console.log(e);
            });
        },
        handleData({ payload }) {
            this.isSGDOn = payload.status;
        },
        handleWsStatus({ status }) {
            this.$store.commit('auth/SET_WS_STATUS', status);
        },
    },
    beforeDestroy() {
        // wsService.off('status-sgd', this.handleData);
        // wsService.off('ws-status', this.handleWsStatus);
    },
};

</script>